import {useMemo, useState} from 'react';

import {Spinner} from '@time-webkit/all/atoms/spinner';

import {ChevronUpNewIcon} from '@time-webkit/all/icons/chevron-up-new';
import {EditSubmitNewIcon} from '@time-webkit/all/icons/edit-submit-icon-new';
import {SendNewIcon} from '@time-webkit/all/icons/send-new';

import classNames from 'classnames';

import styles from './styles.module.css';

type Props = {
    isEdit?: boolean;
    loading?: boolean;
}

export const useSendButtonIcons = ({isEdit, loading}: Props) => {
    const [isRightButtonActive, setIsRightButtonActive] = useState(false);

    const leftButtonIcon = useMemo(() => {
        if (loading) {
            return <Spinner size={16} color='white' />;
        }

        return isEdit ? (
            <EditSubmitNewIcon className={styles.icon} />
        ) : (
            <SendNewIcon className={styles.icon} />
        );
    }, [isEdit, loading]);

    const rightButtonIcon = useMemo(() => (
        <ChevronUpNewIcon
            className={classNames(styles.icon, styles.chevron, {
                [styles.transformed]: isRightButtonActive,
            })}
        />
    ), [isRightButtonActive]);

    return {leftButtonIcon, rightButtonIcon, setIsRightButtonActive, isRightButtonActive};
};
